import React from 'react';
import { UserIcon, Clock, FileEdit, FilePlus2 } from 'lucide-react';

/**
 * Компонент секции трудовых затрат для калькулятора 3D-печати
 */
const LaborCostsSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-purple-50 dark:bg-purple-900/20 p-4 rounded-lg border border-purple-100 dark:border-purple-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <UserIcon className="w-5 h-5 mr-2 text-purple-500" />
        Трудовые затраты
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {/* Стоимость рабочего времени */}
        <div>
          <label htmlFor="laborCostPerHour" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Clock className="w-4 h-4 mr-1 text-purple-500" />
            Стоимость часа работы (₽/ч)
          </label>
          <input
            type="text"
            id="laborCostPerHour"
            name="laborCostPerHour"
            value={formData.laborCostPerHour}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.laborCostPerHour ? 'input-error' : ''}`}
            placeholder="Введите стоимость"
          />
          {errors.laborCostPerHour && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.laborCostPerHour}
            </p>
          )}
        </div>

        {/* Время на подготовку */}
        <div>
          <label htmlFor="preparationTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <FilePlus2 className="w-4 h-4 mr-1 text-purple-500" />
            Время на подготовку (ч)
          </label>
          <input
            type="text"
            id="preparationTime"
            name="preparationTime"
            value={formData.preparationTime}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.preparationTime ? 'input-error' : ''}`}
            placeholder="Введите время"
          />
          {errors.preparationTime && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.preparationTime}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Настройка принтера, слайсинг
          </p>
        </div>

        {/* Время на постобработку */}
        <div>
          <label htmlFor="postProcessingTime" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <FileEdit className="w-4 h-4 mr-1 text-purple-500" />
            Время на постобработку (ч)
          </label>
          <input
            type="text"
            id="postProcessingTime"
            name="postProcessingTime"
            value={formData.postProcessingTime}
            onChange={handleInputChange}
            className={`form-input w-full ${errors.postProcessingTime ? 'input-error' : ''}`}
            placeholder="Введите время"
          />
          {errors.postProcessingTime && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.postProcessingTime}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
            Удаление поддержек, шлифовка и т.д.
          </p>
        </div>
      </div>
      
      <div className="mt-4 bg-purple-100/50 dark:bg-purple-900/30 p-3 rounded-lg border border-purple-200 dark:border-purple-800">
        <div className="flex items-start">
          <Clock className="w-5 h-5 text-purple-600 dark:text-purple-400 mr-3 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-medium text-purple-700 dark:text-purple-300 mb-1">
              О трудовых затратах
            </h4>
            <p className="text-xs text-purple-600 dark:text-purple-400">
              Не забывайте учитывать трудозатраты на подготовку модели, настройку оборудования и постобработку при расчёте стоимости печати. Для сложных моделей постобработка может занимать значительное время, особенно если требуется высокое качество поверхности.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaborCostsSection;